import create from "zustand";
import createVanilla from "zustand/vanilla";

interface ReportFiltersState {
  allVendors: { id: number | string; name: string }[];
  allLocations: { id: number | string; name: string }[];
  setAllVendors: (vendors: { id: number | string; name: string }[]) => void;
  setAllLocations: (locations: { id: number | string; name: string }[]) => void;
}

export const reportFiltersStore = createVanilla<ReportFiltersState>()(
  (set) => ({
    allVendors: [],
    allLocations: [],
    setAllVendors: (vendors) => set({ allVendors: vendors }),
    setAllLocations: (locations) => set({ allLocations: locations }),
  })
);

export const useReportFiltersStore = create(reportFiltersStore);
